import slideStyle from "./InfoPage.module.scss";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { MessageContext, getMessage, Message } from "@messageformat/react";
import { Fragment, useContext, useMemo } from "react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  const content = useMemo(() => {
    const ct = [];
    for (let i = 1; i <= 5; i++) {
      ct.push(
        <Fragment key={i}>
          <h2>
            <Message id={`infoPages.cloud.subheader${i}`} />
          </h2>
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                `infoPages.cloud.subheader${i}Content`
              )(),
            }}
          />
        </Fragment>
      );
    }
    return ct;
  }, [messageContext]);
  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.cloud.subtitle" />}
        title={<Message id="infoPages.cloud.title" />}
        hints={[
          <Message id="infoPages.cloud.hints.hint1" />,
          <Message id="infoPages.cloud.hints.hint2" />,
          <Message id="infoPages.cloud.hints.hint3" />,
        ]}
      />
      <div className={slideStyle.section}>
        <div>
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.cloud.description"
              )(),
            }}
          />

          {content}

          <ContactAppendix />
        </div>
      </div>
    </>
  );
};

export default KioskAI;
